module.exports = __webpack_public_path__ + "static/media/foto-faby.478b28e0.jpg";